import React, {Component} from 'react';
import * as api from '../../../api/analytics-api';
import CustomChart from './CustomChart';
import * as blockUtils from '../../../utils/BlockUtils';
import PropTypes from 'prop-types';
import ErrorBox from '../../utils/ErrorBox';
import ChartsQueryTimeSelector from '../../utils/ChartsQueryTimeSelector';
import {selectedSiteId} from '../../../store';
import i18next from 'i18next';
import {connect} from 'react-redux';
import Cookies from 'universal-cookie';

const QUERY_TIME_COOKIE_KEY = 'analytics-chartsQueryTime';
const cookies = new Cookies();

class SiteKpi extends Component {
  constructor(props) {
    super(props);

    this.getSiteKpis = this.getSiteKpis.bind(this);

    this.state = {
      chartsView: [],
      kpiOptions: {},
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.siteId !== prevProps.siteId) {
      this.getSiteKpis();
    }
  }

  componentDidMount() {
    this.getSiteKpis();
  }

  getSiteKpis() {
    const siteId = this.props.siteId;
    const queryTime = cookies.get(QUERY_TIME_COOKIE_KEY);

    if (!siteId || siteId === -1) {
      return;
    }

    this.setState({
      chartsView: [],
      kpiOptions: {},
    });

    blockUtils.blockUI();
    api.getSiteKpis(siteId, queryTime).then((chartsResponse) => {
      this.setState({
        chartsView: chartsResponse.data.charts,
        kpiOptions: chartsResponse.data.kpiOptions,
      });
      blockUtils.unblockUI();
    }).catch((error) => {
      this.setState({
        noSiteSelectedError: this.getErrorMessage(error, siteId),
      });
      blockUtils.unblockUI();
    });
  }

  getErrorMessage(error, chosenSite) {
    if (error.response.status === 404) {
      return 'No data found for the given site with ID ' + chosenSite;
    } else if (error.response.status === 504) {
      return 'Request to Häfele API for site [' + chosenSite + '] timed out after 10 seconds. Please try again';
    }

    return error.message;
  }

  render() {
    return (
      <div>
        {this.props.noSiteSelectedError && this.props.noSiteSelectedError !== '' ?
          <ErrorBox
            errorMessage={this.props.noSiteSelectedError}
          /> :

          <div>
            <ChartsQueryTimeSelector showTerminals={false} onTimeChange={this.getSiteKpis} />
            <CustomChart
              triggerTabChangeFunc={this.props.triggerTabChangeFunc}
              kpiOptions={this.state.kpiOptions || {}}
              chartViews={this.state.chartsView || []}
            />
          </div>
        }
      </div>
    );
  }
}

SiteKpi.propTypes = {
  noSiteSelectedError: PropTypes.string,
  siteId: PropTypes.number,
  triggerTabChangeFunc: PropTypes.func,
};

const mapStateToProps = function(store) {
  const currentSiteId = store.sitesState.currentSiteId === -1 ? selectedSiteId() : store.sitesState.currentSiteId;
  const selectSiteMessage = currentSiteId === -1 ? i18next.t('terminals.errors.select_site') : '';
  return {
    siteId: currentSiteId,
    noSiteSelectedError: selectSiteMessage,
  };
};

export default connect(mapStateToProps)(SiteKpi);
